import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    // Check pagination before calling parent
    const currentUrl = new URL(window.location.href);
    const currentPage = parseInt(currentUrl.searchParams.get('page')) || 1;
    const dataBlock = this.querySelector('.pagination-info');
    const totalItems = parseInt(dataBlock?.getAttribute('data-total-items') || '0');
    const itemsPerPage = parseInt(dataBlock?.getAttribute('data-items-per-page') || '12');
    const maxPages = Math.ceil(totalItems / itemsPerPage);

    if (currentPage > maxPages || currentPage < 1) {
      // Clean up current instance if exists
      if (this.infinityScrollObserver) {
        this.infinityScrollObserver.disconnect();
        this.infinityScrollObserver = undefined;
      }

      // Reset to page 1
      currentUrl.searchParams.set('page', '1');
      window.location.href = currentUrl.toString();
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          window.location.reload();
        }
      });
      return;
    }

    // If page is valid, continue with parent initialization
    super.connectedCallback();
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
